import { makeStyles } from '../../theme';

export const videoPlayerStyles = makeStyles()(() => ({
  actionCard: {
    backgroundColor: '#25252585!important',
    padding: 8,
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 1,
  },
  errorText: {
    bottom: '45%',
    position: 'absolute',
    textAlign: 'center',
    width: '100%',
  },
  playerButtons: {
    color: '#fff',
    padding: '.125em',
  },
  root: {
    backgroundColor: '#000',
    color: '#fff',
    maxHeight: '100vh',
    maxWidth: '100vw',
    objectFit: 'cover',
    position: 'relative',
    userSelect: 'none',
  },
  video: {},
  videoPlayerControllers: {
    background: 'linear-gradient(transparent, rgba(0,0,0,0.90))',
    bottom: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    padding: '2em 0.75em 0.5em',
    position: 'absolute',
    width: '100%',
  },
}));
